export default __webpack_public_path__ + "static/media/one.22db1940.jpg";